import { Component, Inject, OnInit } from '@angular/core';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CourseTemplate, Learnspace, Course, CourseTemplateData, LearnspaceMode, ExperienceType } from '@shared/models';
import { Observable, of } from 'rxjs';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateTemplateEvent } from '@shared/base-components/template-card.base.component';
import { UIState } from '@shared/directives/ui-state/ui-state.directive';

@Component({
  selector: 'template-picker-dialog',
  templateUrl: './template-picker-dialog.component.html',
  styleUrls: ['./template-picker-dialog.component.scss']
})
export class TemplatePickerDialogComponent implements OnInit {
  public programMode: boolean;
  public state = UIState.default;
  public templates: CourseTemplate[];
  public inactive = false;
  public errorMessage = 'Oops, something went wrong. Please try again later.';

  constructor(
    private _dialogRef: MatDialogRef<TemplatePickerDialogComponent>,
    private _courseService: CoursesAPIService,
    private _http: HttpClient,
    private _router: Router,
    @Inject(MAT_DIALOG_DATA) public _data: { learnspace: Learnspace, route: ActivatedRoute }
  ) { }

  async ngOnInit() {
    this.programMode = this._data.learnspace.mode !== LearnspaceMode.space;

    try {
      this.state = UIState.inprogress;
      const templateData = await this.fetchTemplateData();
      const rawTemplates = templateData.templates.filter(t => !t.hidden);

      // Populate missing attributes for each template with values from DB.
      this.templates = await Promise.all(rawTemplates.map(async (template) => {
        const experience = await this._courseService.getCourseInfo(template.experience_id).toPromise();
        template.title ||= experience.title;
        template.description ||= experience.description;
        template.path ||= experience.postermedia?.path;
        
        template.isMulti = template.isMulti;
        template.is360Only = experience.experience_type === ExperienceType.only360;

        return template;
      }));

      this.state = UIState.default;
    } catch (error) {
      this.state = UIState.error;
    }
  }

  async fetchTemplateData(): Promise<CourseTemplateData> {
    const file = this.programMode ? environment.simulationsTemplateFile : environment.templateFile;
    return this._http.get<CourseTemplateData>(file).toPromise();
  }

  onTemplateSelected(createTemplateEvent: CreateTemplateEvent): void {
    const { template, templateCardComponent } = createTemplateEvent;
    this.inactive = true;
    this._courseService.createCourse(this._data.learnspace.id, template.experience_id, template.title).subscribe(
      (nwCourse) => this.onCourseCreatedSuccess(template, nwCourse),
      () => { templateCardComponent.hasFailed = true; this.inactive = false; }
    );
  }

  onCourseCreatedSuccess(template: CourseTemplate, nwCourse: Course): void {
    if (template.shouldOpenPlayer) {
      window.location.href = environment.coursesApiUrl + '/api/courses/' + nwCourse.id + '/room?poster=false' + (nwCourse.is_multi ? '&presenter=true' : '');
      return;
    }

    this._dialogRef.close();

    let path, params
    if (nwCourse.experience_type === ExperienceType.ai) {
      path = 'simulations';
      params = { queryParams: { create: true } };
    } else {
      path = 'courses';
      params = {};
    }
    this._router.navigate([`./${path}/${nwCourse.id}`], {...params, relativeTo: this._data.route });
  }
}
